import * as yup from 'yup';

export const LoginRequestSchema = yup.object({
    username: yup.string().email('Errors.email_invalid').required('Errors.required'),
    password: yup.string().required('Errors.required'),
});
